export default __webpack_public_path__ + "static/thanos-6c58bda718dd21e480f495d37235da62.png";